import React from 'react';
import { Link } from 'react-router-dom';

import BaseDetailScreen from '../BaseDetailScreen';
import { SUPPORT_EMAIL } from '../../actions/urls';

import './InvestmentViews/styles.css';

export const INVEST_ERROR_TYPE = Object.freeze({ ACCOUNT_RESTRICTED: 0, GENERAL: 1 });

const Component = ({ offer, errorType, accountNumber }) => (
  <BaseDetailScreen
    backTo={`/offers/${offer.id}`}
    backLabel="View Offer Details"
    pageHeading={errorType === INVEST_ERROR_TYPE.GENERAL ? 'Error Investing' : 'Restricted Account'}
  >
    {errorType === INVEST_ERROR_TYPE.GENERAL ?
      <div styleName="errorContainer">
        We apologize for the inconvenience, there was an error processing
        your order. For further details, please&nbsp;
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          styleName="errorPageLink"
        >
          contact support.
        </a>
      </div> :
      <div styleName="errorContainer">
        Your account is currently restricted and cannot invest in offers.
        Please check the&nbsp;<Link to={`/account/${accountNumber}`}>Account Management</Link>
        &nbsp;page for additional information.
      </div>}

  </BaseDetailScreen>
);

Component.displayName = 'ErrorInvesting';

export default Component;



// WEBPACK FOOTER //
// ./src/components/Invest/ErrorInvesting.js